import {EventMatchFields} from "../planning/EventSetupFields";
import React from "react";

export function calendarMatchDetails(event = {}) {
  return {scrimType:event.tag === 'Scrim' ? event.scrimType || '' : '', opponentName: String(event.opponentName ?? event.opponent ?? "").trim().slice(0, 160), competition: String(event.competition || "").trim().slice(0, 160), ...(event.mapSlots ? {mapSlots: event.mapSlots} : {}), matchFormat: ["bo1", "bo3", "bo5", "bo7"].includes(event.matchFormat) ? event.matchFormat : ""};
}
export default function MatchDetailsFields({value, onChange, maps = []}) {

  return <fieldset className="event-editor__full calendar-match-details"><legend>Setup</legend>
    <EventMatchFields value={value} onChange={onChange} maps={maps}/>
  </fieldset>;
}
